import React from "react";

export default (props) => {
    let { id, ...cleanProps } = props;

    return (
        <svg {...cleanProps}>
            <use xlinkHref={`#${id}`}/>
        </svg>
    )
};


// WEBPACK FOOTER //
// ./js/svg/Svg.jsx